import CoreuiController from "../lib/coreui-controller"
import Calendar from "../coreui/calendar"

export default class CoreuiCalendarController extends CoreuiController {
  static Component = Calendar
}
